/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import {CorsAnywhere} from "../CorsAnywhere";
import React from 'react'

/* global WorldWind */

export default class EcmwfSurfaceCH4 extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Surface Methane (CH4)",
            service: CorsAnywhere + "http://apps.ecmwf.int/wms/&token=public",
            version: "1.3.0",
            layerNames: "composition_ch4_surface",
            styleNames: "sh_nipy_spectral_ch4_surface",
        };

        super(cfg);

        this.urlBuilder.transparent = false;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                "© ECMWF",
                WorldWind.Color.LIGHT_GRAY);
        }
    }
    /*<p>Methane is the second most important human emitted greenhouse gas which contribute significantly to
    climate change. One can observe methane hot spots color-coded in red on the data layer.
    Carbon dioxide is more abundant in the atmosphere and often associated with global warming. But methane
    is 30 times more potent as heat-trapping gas than carbon dioxide. It enters the atmosphere mainly from
    the fossil fuel industry, landfill sites, livestock farming, rice agriculture and wetlands.</p>*/

    getLayerDisplayInformation() {
        return (<div>
            <p>Satellite imagery uses different measurement technique that ground sensors, the values provided cannot be directly compared with values provided by local ground sensor.
                The map provided is only representative
                for large scale phenomena, they cannot reproduce local
                aspects of greenhouse gases emissions.</p>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                <img
                    src={"https://apps.ecmwf.int/wms/?token=public&request=GetLegend&layers=composition_ch4_surface&styles=sh_nipy_spectral_ch4_surface&width=350&height=50"}
                    alt={"Legend"}/>
            </div>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                ppbv (parts per billion by volume)
            </p>
            <p>The map is updated at daily at midnight GMT and every six hours.</p>
        </div>);
    }
}
